import { render, staticRenderFns } from "./BeritaFotoList.vue?vue&type=template&id=ba7345a0"
import script from "./BeritaFotoList.vue?vue&type=script&lang=js"
export * from "./BeritaFotoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports